var _path, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgInfoUnfilled = function SvgInfoUnfilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#infoUnfilled_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "infoUnfilled_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 9A9 9 0 1 1 0 9a9 9 0 0 1 18 0Zm-6.818 4.396-.16.652c-.479.189-.86.333-1.146.432-.285.1-.617.149-.994.149-.58 0-1.031-.142-1.353-.425a1.372 1.372 0 0 1-.482-1.077c0-.17.012-.342.036-.519.024-.176.063-.376.116-.598l.595-2.118c.053-.203.098-.396.134-.577.036-.181.055-.347.055-.497 0-.27-.056-.46-.167-.566-.112-.106-.324-.16-.639-.16-.154 0-.313.025-.475.073a6.507 6.507 0 0 0-.417.138l.16-.653c.391-.16.766-.296 1.124-.41a3.36 3.36 0 0 1 1.016-.17c.575 0 1.019.139 1.33.417.313.278.469.64.469 1.084 0 .092-.011.254-.033.486a3.296 3.296 0 0 1-.12.639l-.594 2.11a5.87 5.87 0 0 0-.131.581 3.082 3.082 0 0 0-.058.493c0 .28.063.472.189.573.125.102.343.153.652.153.146 0 .31-.025.494-.076s.317-.096.399-.134Zm-.265-7.919c.278-.258.417-.572.417-.94 0-.367-.139-.681-.417-.942a1.415 1.415 0 0 0-1.005-.392c-.392 0-.728.13-1.008.392-.28.261-.42.575-.42.943 0 .367.14.68.42.94.28.258.616.387 1.008.387s.727-.129 1.005-.388Z",
    fill: "#90929B"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#infoUnfilled_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h18v18H0z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "infoUnfilled_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h18v18H0z"
  })))));
};

export default SvgInfoUnfilled;